import { connect } from 'react-redux';
import { getIsMobile } from 'src/store/view/selectors';
import HotelCardGalleryOverlay from './HotelCardGalleryOverlay';

const mapStateToProps = (state) => ({
  isMobile: getIsMobile(state),
});

export default connect(mapStateToProps)(HotelCardGalleryOverlay);
